import { mapV2CreateReserveRequest } from './v1-to-v2'
import { mapV2Reserve } from './v2-to-v1'

/**
 * @typedef {import('../../../api-v2/js-doc').V1ReserveResponse} V1ReserveResponse
 * @typedef {import('../../../api-v2/js-doc').V1ReserveTotalResponse} V1ReserveTotalResponse
 * @typedef {import('../../../api-v2/js-doc').V2ReserveResponse} V2ReserveResponse
 * @typedef {import('../../../api-v2/js-doc').V2ReserveTotalResponse} V2ReserveTotalResponse
 * @typedef {import('../../../api-v2/js-doc').V2CreateReserveRequest} V2CreateReserveRequest
 */
export class ReservesMapper {
  /**
   * @param {V2ReserveResponse} v2Reserve - V2 reserve
   * @returns {V1ReserveResponse}
   */
  static v2ReserveToV1 (v2Reserve) {
    return mapV2Reserve(v2Reserve)
  }

  /**
   * @param {V2ReserveTotalResponse} v2ReserveTotalResponse - V2 reserve total response
   * @returns {V1ReserveTotalResponse}
   */
  static v2ReserveTotalToV1 (v2ReserveTotalResponse) {
    return {
      total: v2ReserveTotalResponse.amount,
    }
  }

  /**
   * @param {*} v1RequestBody - Represents the V1 create request body
   * @param {*=} v1ResponseBody - Represents the V1 create response body
   * @param {*} ingestingFromV2 - Whether we're ingesting into V2 then to V1
   * @returns {V2CreateReserveRequest}
   */
  static v1ToCreateRequest (v1RequestBody, v1ResponseBody, ingestingFromV2 = false) {
    return mapV2CreateReserveRequest(v1RequestBody, v1ResponseBody, ingestingFromV2)
  }
}
  
